import React, { useState } from 'react';
import { navigate } from 'gatsby';
import { useRecoilState } from 'recoil';
import axios from 'axios';
import { withLocale } from '../../../../utils/hocs/withLocale';
import { returnAPISlug, returnLocalisedPath } from '../../../../utils/globals';
import { alertState } from '../../../../utils/recoil/snackbar';
import { AuthLayout } from '../layout';
import NoozApi from '../../../../services/NoozApi';

export const Signup = withLocale(({ form, image, help, locale }) => {
  const { errorLabels, successLabels, inputs, body, submitButton } = form;
  const [alert, setAlert] = useRecoilState(alertState);

  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = (data) => {
    setIsLoading(true);
    NoozApi.post('/auth/signin', {
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      password: data.password,
    })
      .then((response) => {
        setIsLoading(false);

        if (response.data.message) {
          setAlert({
            ...alert,
            show: true,
            type: 'error',
            title: `${errorLabels[0]?.text} : ${response?.data?.message}`,
          });
        }
        if (response.data.id) {
          setAlert({
            ...alert,
            show: true,
            type: 'success',
            title: successLabels[0]?.text,
          });
          navigate(returnLocalisedPath(locale[0], 'login'));
        }
      })
      .catch(({ response }) => {
        setIsLoading(false);
        setAlert({
          ...alert,
          show: true,
          type: 'error',
          title: `${errorLabels[0]?.text} : ${
            Array.isArray(response?.data?.message)
              ? response?.data?.message[0].message
              : response?.data?.message
          }`,
        });
      });
  };

  return (
    <AuthLayout
      image={image}
      locale={locale}
      help={help}
      form={{
        isLoading,
        onSubmit,
        inputs,
        body,
        submitButton: {
          ...submitButton,
          type: 'contained',
          color: { classname: 'primary' },
          size: 'lg',
        },
      }}
    />
  );
});
